const pairwiseSumReduce = (array, f, init=0) => {
  let n = array.length;
  return array.reduce((acc, p, i) => {
    if ((i+1) >= n) {
      return acc;
    }
    return acc + f(p, array[i+1], i, array);
  }, init);
};

export class Ring {
  static isCCW(points:number[][]) {
    let sum = 0;
    let len = points.length;
    let open = points[0][0] !== points[len-1][0] || points[0][1] !== points[len-1][1];
  
    if (open) points.push(points[0]);
    for (let i=1; i<len; i++) {
      sum += (points[i][0] - points[i-1][0]) * (points[i][1] + points[i-1][1]);
    }
    if (open) points.pop();
    return (sum <= 0);
  }
  
  // Calculate the area of the polygon.
  // "46252042.8635226"
  static area(points:number[][]) : number {
    return pairwiseSumReduce(points, (p1, p2) => p1[0] * p2[1] - p1[1] * p2[0]) / 2;
  };

  static centroid(points:number[][]) : [number,number] {
    let area = Ring.area(points);
    let cx = pairwiseSumReduce(
      points,
      (p1, p2) => (p1[0] + p2[0]) * (p1[0] * p2[1] - p1[1] * p2[0])
    ) / (6 * area);
    let cy = pairwiseSumReduce(points,
      (p1, p2) => (p1[1] + p2[1]) * (p1[0] * p2[1] - p1[1] * p2[0])
    ) / (6 * area);

    return [cx, cy];
  }

  static inSide(point:[number,number], points:number[][]) : boolean {
    let x = point[0], y = point[1];
    let inside = false;
    let i, j
    for (let i=0, j=points.length-1; i<points.length; j=i++) {
      let xi = points[i][0], yi = points[i][1];
      let xj = points[j][0], yj = points[j][1];
      let intersect = ((yi > y) != (yj > y))
          && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }
}
